import React, { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { Dashboard } from 'schemas/DashboardSchema'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { getWidgetForDashboard } from 'features/widget/asyncThunks'
import { toFilter } from 'utils/widgetUtil'
import { createTopSearch } from 'utils/runSearchUtil'
import { ServiceType } from 'enums'
import { RunSearch } from 'schemas/action/RunSearchSchema'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import { PopularLinksWidgetsType } from '../../types'

interface RunSearchEffectProps {
  widgetId: number
  children: React.ReactElement
}

const createSearch = (
  widgetSetting: PopularLinksWidgetsType,
  dashboardData: Dashboard
): RunSearch => {
  const filter = toFilter(widgetSetting)

  return createTopSearch(
    dashboardData.id!,
    dashboardData.name!,
    widgetSetting.precision!,
    [widgetSetting.selectedTopic.topicId!],
    filter,
    widgetSetting.topN!,
    'MostShared',
    ServiceType.SW_TOP_LINKS
  )
}

const RunSearchEffect = ({ widgetId, children }: RunSearchEffectProps): React.ReactElement => {
  const widgetSetting = useDashboardWidgetSetting<PopularLinksWidgetsType>(widgetId)
  const dashboardData = useDashboardData()
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const search = createSearch(widgetSetting, dashboardData!)

    dispatch(
      getWidgetForDashboard({
        searches: [search],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, dispatch, refreshTimestamp])

  return children
}

export default RunSearchEffect
